import { NotificationKind } from '@/enums/notification'
import i18n from '@/libs/i18n'

/*
 * The sentence of a notification (docs/API.md → Notifications: "the web renders the sentence
 * from kind + fields"). Like a history line it names what happened and leaves the task and
 * the person to the row around it, so no verb has to agree with anybody's gender.
 */
export const notificationSentence = (kind: string): string => {
    switch (kind) {
        case NotificationKind.Assigned:  return i18n.global.t('notification.assigned')
        case NotificationKind.Commented: return i18n.global.t('notification.commented')
        case NotificationKind.DueSoon:   return i18n.global.t('notification.due_soon')
        case NotificationKind.Overdue:   return i18n.global.t('notification.overdue')
        default:                         return kind
    }
}

export const notificationIcon = (kind: string): string => {
    switch (kind) {
        case NotificationKind.Assigned:  return 'i-lucide-user-round-check'
        case NotificationKind.Commented: return 'i-lucide-message-square'
        case NotificationKind.DueSoon:   return 'i-lucide-alarm-clock'
        case NotificationKind.Overdue:   return 'i-lucide-triangle-alert'
        default:                         return 'i-lucide-bell'
    }
}

export const notificationColor = (kind: string): string => {
    switch (kind) {
        case NotificationKind.Overdue: return 'bg-error/10 text-error'
        case NotificationKind.DueSoon: return 'bg-warning/10 text-warning'
        default:                       return 'bg-primary/10 text-primary'
    }
}
